import { render, staticRenderFns } from "./statisticsNew1.vue?vue&type=template&id=6557aac3&scoped=true&"
import script from "./statisticsNew1.vue?vue&type=script&lang=js&"
export * from "./statisticsNew1.vue?vue&type=script&lang=js&"
import style0 from "./statisticsNew1.vue?vue&type=style&index=0&id=6557aac3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6557aac3",
  null
  
)

export default component.exports